import { createFileRoute } from "@tanstack/react-router";
import { AuthFlow } from "@/components/auth-flows";

export const Route = createFileRoute("/signup")({
  validateSearch: (search: Record<string, unknown>): { redirect?: string } => {
    const r = search["redirect"];
    return typeof r === "string" ? { redirect: r } : {};
  },

  head: () => ({
    meta: [
      { title: "Xamseen — Join Xamseen" },
      { name: "description", content: "Create your Xamseen account and start participating in your community: report issues, discover solutions and join projects." },
      { property: "og:title", content: "Join Xamseen" },
      { property: "og:description", content: "Create your Xamseen account and start participating in your community." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: SignUpPage,
});

function SignUpPage() {
  const { redirect } = Route.useSearch();
  return <AuthFlow initialMode="signup" redirectTo={redirect} />;
}
